export default {
  init() {
    // JavaScript to be fired on all pages
    function homeSliderHeight() {
      $('.home-slider .inner-container').height($(window).innerHeight());
    }
    homeSliderHeight();
    window.setTimeout(homeSliderHeight, 500);
    $(window).on('resize', homeSliderHeight);
    $('[data-slick]').slick({
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fas fa-caret-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fas fa-caret-right"></i></button>',
    });

    // Navbar
  
    $('#mainMenu').on('show.bs.collapse', function () {
      $('.mainNavbar').addClass('mainNavbar_open');
    })

    $('#mainMenu').on('hide.bs.collapse', function () {
      $('.mainNavbar').removeClass('mainNavbar_open');
    })

    // Underline
    const underlinedItems = document.querySelectorAll('.legance-underline');

    underlinedItems.forEach(item => {
      var content = item.innerHTML;
      content = content + ' ';
      item.innerHTML = content.replace(
        /(.+?)([\s,.!?;:)([\]]+)/g,
        '<span>$& </span>'
      );
      item.classList.remove('legance-underline');
      item.classList.add('legance-underline-span');
    });

    // Load more

    $('.load-more').on('click', function(e) {
      e.preventDefault();
      var $this = $(this);
      var url, loopSelector;

      if ($('body').hasClass('post-type-archive-professionisti') || $('body').hasClass('search-results')) {
        url = $this
          .attr('href')
          .replace(
            /(.+)\/page\/\d+\/(.{0,100})(wpv_paged=)(\d+)(.{0,100})/gi,
            '$1/page/$4/$2$3$4$5'
          );
        
        if($('body').hasClass('post-type-archive-professionisti')) {
          loopSelector = '.wpv-loop';
        }else {
          loopSelector = '.search-loop';
        }
      } else {
        url = $this.attr('href');
        loopSelector = 'main.main > .loop';
      }

      $this.css('opacity', 0.5);

      $.ajax({
        url: url,
        type: 'get',
        dataType: 'html',
        success: function(response) {
          var $html = $(response).find(loopSelector);
          var previous = $(response)
            .find('.load-more')
            .attr('href');
          if (previous == undefined) {
            $('.load-more').remove();
          } else {
            $('.load-more').attr('href', previous);
          }

          var lastYear = $('.loopItem__aside h4')
            .last()
            .text();
          if (
            lastYear &&
            $html
              .find('.loopItem__aside h4')
              .first()
              .text() == lastYear
          ) {
            $html
              .find('.loopItem__aside h4')
              .first()
              .remove();
          }

          $(loopSelector).append($html.html());
          $this.css('opacity', 1);
        },
        error: function() {
          $this.css('opacity', 1);
          $('.load-more').remove();
        },
      });
      return false;
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $('a').each(function() {
      var a = new RegExp('/' + window.location.host + '/');
      if (!a.test(this.href)) {
        $(this).click(function(event) {
          event.preventDefault();
          event.stopPropagation();
          window.open(this.href, '_blank');
        });
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js